import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { HomeComponent } from "./pages/home";
import { LoginComponent } from "./pages/auth/login";
import { AuthentificationComponent } from "./pages/auth/authentification/authentification.component";
import { RegisterComponent } from "./pages/auth/register/register.component";
import { PasswordResetComponent } from "./pages/auth/password-reset/password-reset.component";
import { ForgotPasswordComponent } from "./pages/auth/forgot-password/forgot-password.component";
import { FilesComponent } from "./pages/files/files-list/files.component";
import { FileComponent } from "./pages/files/file-view/file.component";
import { UsersComponent } from "./pages/users/users.component";
import { UploadComponent } from "./pages/upload/upload.component";
import { EditComponent } from "./pages/edit/edit.component";
import { AuthGuard } from "./_helpers";
import { MobilpayComponent } from "./pages/mobilpay/mobilpay.component";
import { ActivateAccountComponent } from "./pages/auth/activate-account/activate-account.component";
import { PayComponent } from "./pages/pay/pay.component";
import { ThankYouComponent } from "./pages/thank-you/thank-you.component";
import { FileSimpleComponent } from "./pages/files/file-simple/file-simple.component";
import { FileCompareComponent } from "./pages/files/file-compare/file-compare.component";
import { ChartsComponent } from "./pages/files/charts/charts.component";
import { FileDiagnosticComponent } from "./pages/files/file-diagnostic/file-diagnostic.component";
import { SubscriptionsComponent } from "./pages/subscriptions/subscriptions.component";
import { BudgetComponent } from "./pages/budget/budget.component";

const routes: Routes = [
  // { path: '', component: HomeComponent },
  { path: "", component: FilesComponent },
  { path: "login", component: LoginComponent },
  { path: "authentification", component: AuthentificationComponent },
  { path: "register", component: RegisterComponent },
  { path: "password-reset", component: PasswordResetComponent },
  { path: "activate-account", component: ActivateAccountComponent },
  { path: "forgot-password", component: ForgotPasswordComponent },
  { path: "files", component: FilesComponent, canActivate: [AuthGuard] },
  { path: "file/:id", component: FileComponent, canActivate: [AuthGuard] },
  { path: "file/:language/:id", component: FileComponent, canActivate: [AuthGuard] },
  { path: "charts", component: ChartsComponent, canActivate: [AuthGuard] },
  {
    path: "file-s/:id",
    component: FileSimpleComponent,
    canActivate: [AuthGuard],
  },
  { path: "diagnostic/:id", component: FileDiagnosticComponent, canActivate: [AuthGuard] },
  { path: "users", component: UsersComponent, canActivate: [AuthGuard] },
  { path: "upload", component: UploadComponent, canActivate: [AuthGuard] },
  { path: "edit", component: EditComponent, canActivate: [AuthGuard] },
  { path: "buget", component: BudgetComponent, canActivate: [AuthGuard] },
  { path: "abonamente", component: SubscriptionsComponent, canActivate: [AuthGuard] },
  { path: "pay", component: PayComponent, canActivate: [AuthGuard] },
  { path: "thank-you", component: ThankYouComponent, canActivate: [AuthGuard] },
  { path: "comparatii", component: FileCompareComponent, canActivate: [AuthGuard] },
  {
    path: "tranzactii",
    component: MobilpayComponent,
    canActivate: [AuthGuard],
  },

  // otherwise redirect to home
  { path: "**", redirectTo: "" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: "legacy" })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
